import React from 'react';

import useEndOfVideo from '../../hooks/useEndOfVideo';
import EndOfVideoPanel from '../EndOfVideoPanel/EndOfVideoPanel';

interface IEndOfVideoPanelWrapperProps {
    closeAll(): void;
}
export const EndOfVideoPanelWrapper = (props: IEndOfVideoPanelWrapperProps) => {
    const endOfVideoProps = useEndOfVideo();
    const progressSavedAt = React.useRef(new Date());

    return <EndOfVideoPanel
        {...endOfVideoProps}
        progressSavedAt={progressSavedAt.current}
        onPlaySegment={props.closeAll}
    />;
};
